import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { App } from './app';
import { dismissAppPreloader, initAppPreloader } from './app-preloader';
import './styles.css';

// Los mensajes del preloader arrancan antes que Angular: así el primer frame
// ya comunica algo en vez de quedarse en silencio hasta que descarga el bundle.
initAppPreloader();

bootstrapApplication(App, appConfig)
  .catch((err) => {
    console.error(err);
    // El arranque falló: si dejamos el preloader, el usuario se queda mirando
    // un indicador eterno en vez de ver la página real (y su error).
    dismissAppPreloader();
  });
